module.exports = __webpack_public_path__ + "img/changeActivationType.a20c04eb.svg";